import { Outlet, useLocation } from "react-router-dom";
import Footer from "../Footer/Footer.jsx";
import Navbar from "../Navbar/Navbar.jsx";
import { Fragment } from "react";

export default function Layout() {

   const location = useLocation();
   const hideFooterPages = ["offers", "register", "order", "cart", "addTest",];
   const shouldHideFooter = hideFooterPages.includes(location.pathname.split("/")[1]);


   return (
      <Fragment>
         <Navbar />

         <Outlet></Outlet>

         {/* <Offline>
            <div className="network text-danger">
               <img src={notConnection} alt="not-Connection"/>
            </div>
         </Offline> */}

         {/* <Offline>
            <div className="network text-danger">
               <i className="fa-solid fa-wifi p-1 "></i> Network Offline
            </div>
         </Offline> */}

         {/* <Online>
            <div className="network fixed-bottom text-success">
               <i className="fa-solid fa-wifi p-1 "></i> Network Online
            </div>
         </Online> */}

         {!shouldHideFooter && <Footer />}
      </Fragment>
   )
}